import { openBlock as t, createElementBlock as i, createElementVNode as l } from "vue";
function a(e, h) {
  return t(), i("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    l("g", { "clip-path": "url(#clip0_1046_3591)" }, [
      l("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      l("path", {
        d: "M22.5406 6.26036C20.99 3.41837 18.3236 1.27295 15.1301 0.412231L14.6084 6.26036H22.5406Z",
        fill: "#0052B4"
      }),
      l("path", {
        d: "M1.45898 6.2606H9.39117L8.86945 0.412476C5.676 1.27319 3.00966 3.41866 1.45898 6.2606Z",
        fill: "#0052B4"
      }),
      l("path", {
        d: "M14.6084 12.0017V17.7408H22.5406C23.4708 16.036 23.9997 14.0806 23.9997 12.0017H14.6084Z",
        fill: "#6DA544"
      }),
      l("path", {
        d: "M9.39131 12.0007H0C0 14.0796 0.528891 16.035 1.45908 17.7399H9.39127V12.0007H9.39131Z",
        fill: "#6DA544"
      }),
      l("path", {
        d: "M1.45898 17.7396C3.00966 20.5816 5.676 22.727 8.86945 23.5878L9.39117 18.4733L1.45898 17.7396Z",
        fill: "#FFDA44"
      }),
      l("path", {
        d: "M15.1301 23.5884C18.3236 22.7276 20.99 20.5822 22.5406 17.7402L14.6084 18.4738L15.1301 23.5884Z",
        fill: "#FFDA44"
      }),
      l("path", {
        d: "M14.6084 18.4738L22.5406 17.7402H14.6084V18.4738Z",
        fill: "#FFDA44"
      }),
      l("path", {
        d: "M9.39122 17.7396H1.45898L9.39122 18.4732V17.7396Z",
        fill: "#FFDA44"
      }),
      l("path", {
        d: "M12.0006 0.000366211C10.9174 0.000366211 9.86827 0.144741 8.87012 0.413757V23.587C9.86827 23.856 10.9174 24.0004 12.0006 24.0004C13.0837 24.0004 14.1329 23.856 15.131 23.587V0.413757C14.1329 0.144741 13.0837 0.000366211 12.0006 0.000366211Z",
        fill: "#D80027"
      }),
      l("path", {
        d: "M6.45438 2.60913L6.7781 3.60555H7.8259L6.9783 4.2214L7.30207 5.21782L6.45438 4.60202L5.60674 5.21782L5.9306 4.2214L5.08301 3.60555H6.13071L6.45438 2.60913Z",
        fill: "#FFDA44"
      })
    ]),
    l("defs", null, [
      l("clipPath", { id: "clip0_1046_3591" }, [
        l("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
export {
  a as default
};
